import { Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Pages
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";

// Dashboards
import AdminDashboard from "./components/admin/AdminDashboard";
import UserDashboard from "./pages/user/UserDashboard";

// Contexts
import { AuthProvider } from "./contexts/AuthContext";

// Components
import ProtectedRoute from "./components/routes/ProtectedRoute";

// Admin Components

import { NotificationProvider } from "./contexts/NotificationContext";
import ContributionsList from "./components/admin/AllContributions";

export default function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <ToastContainer position="top-right" autoClose={2500} />

        <Routes>
          {/* ---------- Public Routes ---------- */}
          <Route path="/" element={<Home />} />

          {/* ---------- Admin Routes ---------- */}
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute allowedRoles={["admin", "superadmin"]}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/orders"
            element={
              <ProtectedRoute allowedRoles={["admin", "superadmin"]}>
                <ContributionsList />
              </ProtectedRoute>
            }
          />

          {/* ---------- Staff/User Dashboard ---------- */}
          <Route
            path="/user"
            element={
              <ProtectedRoute allowedRoles={["staff"]}>
                <UserDashboard />
              </ProtectedRoute>
            }
          />

          {/* ---------- 404 Page (Must be last) ---------- */}
          <Route path="*" element={<NotFound />} />
        </Routes>

        {/* <CartIcon /> */}
      </NotificationProvider>
    </AuthProvider>
  );
}
